/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-explicit-any */

export function preloadAllImages() {
  const importAll = (r: any) => r.keys().map(r)

  const images = importAll(
    // @ts-ignore - webpack feature
    require.context('../assets/images', false, /\.(png|jpe?g|webp|avif)$/),
  )

  images.forEach((src: string) => {
    const img = new Image()
    img.src = src
  })
}
